import { GET_ACTIVITIES, LOGOUT } from '../actions/types';
const initialState = {
  activity: null,
  activities: []
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ACTIVITIES:
      return {
        ...state,
        activities: payload
      };
    case LOGOUT:
      return {
        ...state,
        activity: null,
        activities: []
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/activity.js